import { memo, useRef } from 'react';
import { deserialize } from 'react-serialize';
import { useClickTracking } from '../../hooks/useClickTracking';
import { useOnImgRendered } from '../../hooks/useOnImgRendered';
import { stringify } from '../../utils/polyfills';
function ItemComponent(_a) {
    var element = _a.element, _b = _a.onLinkClick, onLinkClick = _b === void 0 ? function () { return Promise.resolve(null); } : _b, _c = _a.onRendered, onRendered = _c === void 0 ? function () { } : _c;
    var ref = useRef(null);
    var stringTemplate = stringify({
        type: 'p',
        props: { children: element },
    });
    if (!element) {
        return null;
    }
    var output = typeof element === 'object'
        ? deserialize(element)
        : deserialize(stringTemplate);
    var clonedElement = useOnImgRendered(output, ref, onRendered);
    useClickTracking(ref, onLinkClick);
    return clonedElement;
}
var genericMemo = memo;
export var Item = genericMemo(ItemComponent);
